import {
  params, shape, string, number, bool, arrayOf, extend
} from '@thd-nucleus/data-sources';
import { SettingsForm } from '@thd-olt-component-react/list-forms';

export const dataModel = extend({
  list: params({ id: string().isRequired() }).shape({
    id: string(),
    name: string(),
    url: string(),
    public: bool(),
    itemCount: number(),
    listAccessType: string(),
    images: arrayOf(shape({
      url: string()
    }))
  })
}, SettingsForm);
